const getQueryString = (query: { [key: string]: string | undefined }, key: string, value: string) => {
  const filteredParams: Record<string, string> = {};
  Object.entries(query).forEach(([queryKey, queryValue]) => {
    if (typeof queryValue === 'string' && queryValue !== '') {
      filteredParams[queryKey] = queryValue;
    }
  });

  if (value) {
    filteredParams[key] = value.toLowerCase();
  }

  const searchParams = new URLSearchParams(filteredParams);
  const searchString = searchParams.toString();
  const formattedSearchString = searchString ? `?${searchString}` : '';
  return formattedSearchString;
};

export default getQueryString;
